import { useState } from "react";
import BaseInput from "../BaseInput";

const EmailInput = ({ value, onInput, label = 'Email', placeholder = 'exemplo@email.com', variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value || "");

    const handleChange = (newValue) => {
        // Remove all spaces and only allow valid email characters: letters, numbers, @, ., -, _
        const cleanedValue = newValue
            .replace(/\s/g, '') // Remove all whitespace first
            .replace(/[^a-zA-Z0-9@._-]/g, '') // Remove any other invalid characters
            .toLowerCase();

        setLocalValue(cleanedValue);
        onInput(cleanedValue);
    };

    return (
        <BaseInput
            {...props}
            value={localValue}
            onInput={handleChange}
            label={label}
            placeholder={placeholder}
            variant={variant}
        />
    );
};

export default EmailInput;
